import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {makeGetVisualParticipants} from '../../../store/data/contacts/participantsSelectors';
import {getUserNamespace} from '../../../store/data/teammates/teammatesSelectors';
import {focusCalendarEventAction} from '../../../store/panels/calendars/calendarsPanelActions';
import {CalendarEventData} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {CalendarsPanelId} from '../../../store/panels/panelStateBase';
import {SideCalendarEventViewer} from './sideCalendarEventViewer';

/*
 * Props.
 */

interface SideCalendarEventViewerContainerProps {
  panelId: CalendarsPanelId;
  calendarEventData: CalendarEventData;
}

/*
 * Selectors.
 */

function getCalendarEvent(_state: AppState, props: SideCalendarEventViewerContainerProps) {
  return props.calendarEventData.calendarEvent;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SideCalendarEventViewerContainerProps>()(() => ({
  visualParticipants: makeGetVisualParticipants(getUserNamespace, getCalendarEvent),
}));

const mapDispatchToProps = makeMapDispatchToProps<SideCalendarEventViewerContainerProps>()(({panelId}) => ({
  onBackClick: () => focusCalendarEventAction(panelId, undefined),
}));

export const SideCalendarEventViewerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SideCalendarEventViewer);
